import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromStaticDataReducer from '../reducers';
import * as staticDataCountriesReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataClientTypesState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataClientTypesReducer.staticDataClientTypesFeatureKey]
);

export const getStaticDataClientTypesFailure = createSelector(
  getStaticDataClientTypesState,
  staticDataCountriesReducer.fromStaticDataClientTypesReducer.getClientTypesError
);

export const getStaticDataClientTypesResponse = createSelector(
  getStaticDataClientTypesState,
  staticDataCountriesReducer.fromStaticDataClientTypesReducer.getClientTypes
);
